module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aMB3j"))).then(() => parcelRequire('9Lwss'));